import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  // Fail fast in dev; in prod this will surface quickly in monitoring.
  throw new Error("Missing Supabase env vars: VITE_SUPABASE_URL and/or VITE_SUPABASE_ANON_KEY");
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

/**
 * Removes Supabase Auth persistence from browser storage after signOut.
 * FIX: signOut() can complete before all sb-* keys are gone (timing / multi-tab); stale keys make getSession() still look logged-in on the next full navigation (E2E: /dashboard stayed reachable).
 */
export function clearSupabaseAuthStorage(): void {
  try {
    for (const k of Object.keys(localStorage)) {
      if (k.startsWith("sb-")) localStorage.removeItem(k);
    }
    for (const k of Object.keys(sessionStorage)) {
      if (k.startsWith("sb-")) sessionStorage.removeItem(k);
    }
  } catch {
    /* ignore (e.g. storage disabled) */
  }
}

